// permission.directive.ts
import { CommonModule } from '@angular/common';
import {
    Directive,
    Input,
    NgModule,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';
import { Subscription, filter, take } from 'rxjs';
import { AuthorizationService } from '../services/authorization.service';

@Directive({
  selector: '[lcmsPermission]',
})
export class PermissionDirective implements OnInit, OnDestroy {
  @Input('lcmsPermission') permissions: string[] | string;
  private subscription: Subscription;
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authorizationService: AuthorizationService,
  ) {}

  ngOnInit(): void {
    // console.log('inside permission==>', this.permissions);
    const permissionsArray = Array.isArray(this.permissions)
      ? this.permissions
      : [this.permissions];

    this.checkPermissions(permissionsArray);
    this.subscription = this.authorizationService.userPermissions$
      .pipe(
        filter((data) => data && data.length > 0),
        take(1)
      )
      .subscribe((data) => {
        if (this.checkPermissions(permissionsArray) && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else if (!this.checkPermissions(permissionsArray) && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }

      });
  }


  checkPermissions(permissions: any): boolean {

    if (permissions.includes('||')) {
      // Check if any of the permissions is valid (logical OR)
      const validPermissions = permissions.filter(
        (permission: any) => permission !== '||'
      );
      // console.log(
      //   'inside permission check OR===> ',
      //   validPermissions,
      //   validPermissions.some((permission: any) =>
      //     this.authorizationService.hasPermission(permission)
      //   )
      // );

      return validPermissions.some((permission: any) =>
        this.authorizationService.hasPermission(permission)
      );
    } else if (permissions.includes('&&')) {
      // Check if all of the permissions are valid (logical AND)
      const validPermissions = permissions.filter(
        (permission: any) => permission !== '&&'
      );
      // console.log(
      //   'inside permission check AND===> ',
      //   validPermissions,
      //   validPermissions.every((permission: any) =>
      //     this.authorizationService.hasPermission(permission)
      //   )
      // );
      return validPermissions.every((permission: any) =>
        this.authorizationService.hasPermission(permission)
      );
    } else {
      // Single permission check
      return this.authorizationService.hasPermission(permissions[0]);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [PermissionDirective],
  exports: [PermissionDirective],
})
export class PermissionDirectiveModule {}
